import utils from './utils';

const URL = `${BASE_API_URL}/countries`;

export default {
    getCountries: () => utils.get(`${URL}/list.json`),
}



// WEBPACK FOOTER //
// ./src/api/countries.js